module.exports = __webpack_public_path__ + "img/HowtoCategory3.79eb14f7.png";